import { createFileRoute } from "@tanstack/react-router";
import { Spinner, Table } from "@heroui/react";

import { TariffEntity, useTariffs } from "@/features/tariffs/use-tariffs.ts";

export const Route = createFileRoute("/dashboard/tariffs/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data, isPending } = useTariffs({});

  return (
    <div className="flex flex-col pt-4 pr-4">
      <div className="flex flex-row gap-2 justify-between h-12 items-center">
        <p className="font-bold text-xl">Тарифы</p>
      </div>

      {isPending ? (
        <div className="flex justify-center py-8">
          <Spinner />
        </div>
      ) : (
        <Table.Root className="mt-8">
          <Table.Content aria-label="Список тарифов">
            <Table.Header>
              <Table.Column>ID</Table.Column>
              <Table.Column>Картинка</Table.Column>
              <Table.Column>Название</Table.Column>
              <Table.Column>Описание</Table.Column>
              <Table.Column>Иконка</Table.Column>
              <Table.Column>Активна</Table.Column>
              <Table.Column>Длина (в см)</Table.Column>
              <Table.Column>Высота (в см)</Table.Column>
              <Table.Column>Ширина (в см)</Table.Column>
              <Table.Column>Объемный вес (в кг.)</Table.Column>
              <Table.Column>Реальный вес (в кг.)</Table.Column>
              <Table.Column>Фактурный вес (в кг.)</Table.Column>
              <Table.Column>Цена себестоимости авиа отправки за 1 кг</Table.Column>
              <Table.Column>Упаковка товара в среднем за еденицу</Table.Column>
              <Table.Column>Доп расход на хрупкий груз</Table.Column>
              <Table.Column> </Table.Column>
            </Table.Header>
            <Table.Body items={data?.data ?? []}>
              {(tariff: TariffEntity) => (
                <Table.Row id={String(tariff.id)}>
                  <Table.Cell>{tariff.id}</Table.Cell>
                  <Table.Cell>
                    <img
                      src={tariff.image}
                      alt={tariff.name}
                      className="h-14 w-auto object-contain"
                    />
                  </Table.Cell>
                  <Table.Cell>{tariff.name}</Table.Cell>
                  <Table.Cell>{tariff.description}</Table.Cell>
                  <Table.Cell>{tariff.icon}</Table.Cell>
                  <Table.Cell>{tariff.isActive ? "Да" : "Нет"}</Table.Cell>
                  <Table.Cell>{tariff.length}</Table.Cell>
                  <Table.Cell>{tariff.height}</Table.Cell>
                  <Table.Cell>{tariff.width}</Table.Cell>
                  <Table.Cell>{tariff.volumetricWeight}</Table.Cell>
                  <Table.Cell>{tariff.weight}</Table.Cell>
                  <Table.Cell>{tariff.invoiceWeight}</Table.Cell>
                  <Table.Cell>{tariff.costPriceOfAirShipment}</Table.Cell>
                  <Table.Cell>{tariff.package.name}</Table.Cell>
                  <Table.Cell>{tariff.additionalCostForFragileCargo}</Table.Cell>
                  <Table.Cell>
                    <div className="flex flex-row gap-2 justify-end" />
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table.Content>
        </Table.Root>
      )}
    </div>
  );
}
